import { makeStyles } from '@material-ui/core/styles'
import {
  Theme,
  RadioGroup,
  Typography,
  Grid,
  FormControlLabel,
} from '@material-ui/core'
import { specificationItem } from '../ProductsConfiguration'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'

const useStyles = makeStyles((theme: Theme) => ({
  dropDown: {
    paddingTop: theme.spacing(4),
  },
}))
interface SpecificationRadio {
  list: specificationItem[]
  specificationName: string
  specificationValue: string | undefined
  handleChange: (event: React.ChangeEvent<{ value: unknown }>) => void
}

const SpecificationRadio = ({
  list,
  specificationName,
  specificationValue,
  handleChange,
}: SpecificationRadio) => {
  const classes = useStyles()

  return (
    <Grid item xs={12} className={classes.dropDown}>
      <RadioGroup
        aria-label="specifications"
        name={specificationName}
        onChange={handleChange}
        value={specificationValue}
        row
      >
        {list?.map((option) => {
          if (list.length === 1) {
            return <Typography key={option.key}>{option.value}</Typography>
          }

          return (
            <FormControlLabel
              control={<StyledRadio isConfiguratorsRedesign="true" />}
              label={<Typography>{option.value}</Typography>}
              value={option.key}
              disabled={option.enabled === false}
              key={option.key}
            />
          )
        })}
      </RadioGroup>
    </Grid>
  )
}

export default SpecificationRadio
